import React, { useState } from 'react';
import { KatTabs, KatTab } from '@amzn/katal-react';
import TellerTab from "src/components/TellerTab";
import OFATab from "src/components/OFATab";
import OFATestCaseData from "src/components/OFATestCaseData";
import TestCaseData from "src/components/TestCaseData";
import TestExecutionTab from "src/components/TestExectionTab";

const TestPilotTabs: React.FC = () => {
    const [selectedTab, setSelectedTab] = useState<string>('ExecutionTab');
    const [tellerReloadKey, setTellerReloadKey] = useState<number>(0);
    const [ofaReloadKey, setOfaReloadKey] = useState<number>(0);


    const handleTabChange = (event: CustomEvent<{ selected: string }>) => {
        setSelectedTab(event.detail.selected);
    };

    return (
        <div>
            <KatTabs selected={selectedTab} onChange={handleTabChange} className="custom-tab-style">
                <KatTab tabId="OfaTab" label="OFA">
                    <OFATab onSaveSuccess={() => setOfaReloadKey(prev => prev + 1)} />
                </KatTab>
                <KatTab tabId="TellerTab" label="Teller">
                    <TellerTab onSaveSuccess={() => setTellerReloadKey(prev => prev + 1)} />
                </KatTab>
                <KatTab tabId="ExecutionTab" label="Execution">
                </KatTab>
            </KatTabs>

            {/* Table display based on selected tab */}
            <div style={{ marginTop: '1rem' }}>
                {selectedTab === 'TellerTab' && <TestCaseData key={tellerReloadKey} />}
                {selectedTab === 'OfaTab' && <OFATestCaseData key={ofaReloadKey}/>}
                {selectedTab === 'ExecutionTab' && <TestExecutionTab />}
            </div>
        </div>
    );
};

export default TestPilotTabs;
